<template>
    <div
        v-if="
            Object.keys(currentScreen).length > 0 &&
            Object.keys(layout).length > 0
        "
    >
        <!-- :style="index > 0 ? 'margin-top: 80px' : ''" -->
        <template v-for="(page, index) in layout.pages">
            <div class="page" :key="index">
                <template v-for="(section, j) in page">
                    <v-component
                        :mode="mode"
                        :is="section.component"
                        :key="j"
                        v-bind="getAttributes(section.params)"
                    ></v-component>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "order-print",
    components: {
        AppHeader: () => import("@/layouts/print/AppHeader.vue"),
        ScreeningRatings: () =>
            import("@components/screen/components/Print/ScreeningRatings"),
        ApplicantProfile: () =>
            import("@components/screen/components/Print/ApplicantProfile"),
        ApplicantCredit: () =>
            import("@components/screen/components/Print/ApplicantCredit"),
        ApplicantDebt: () =>
            import("@components/screen/components/Print/ApplicantDebt"),
        ScreenRecommendation: () =>
            import("@components/screen/components/Print/ScreenRecommendation"),
        ScreeningScorecard: () =>
            import("@components/screen/components/Print/ScreeningScorecard"),
        HouseholdIncomes: () =>
            import("@components/screen/components/Print/HouseholdIncomes"),
        RentalHistory: () =>
            import("@components/screen/components/Print/RentalHistory"),
        ApplicantCrime: () =>
            import("@components/screen/components/Print/ApplicantCrime"),
        ApplicantEvictions: () =>
            import("@components/screen/components/Print/ApplicantEvictions"),
        CrimeDisclaimer: () =>
            import("@components/screen/components/Print/CrimeDisclaimer"),
        CrimeSummary: () =>
            import("@components/screen/components/Print/CrimeSummary"),
    },
    props: {
        mode: {
            type: String,
            required: false,
            default: "print",
        },
    },
    data() {
        return {
            layout: {},
        };
    },

    computed: {
        ...mapGetters("Screens", ["currentScreen", "currentApplication"]),
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(to) {
                this.getPrintableScreen({
                    id: to.params.id,
                    expires: this.$_.get(to, "query.expires", ""),
                    signature: this.$_.get(to, "query.signature"),
                });
            },
        },
        currentScreen(screen) {
            if (Object.keys(screen).length > 0) {
                this.buildLayout();
            }
        },
    },
    methods: {
        ...mapActions("Screens", ["getPrintableScreen"]),
        getAttributes(params) {
            let attr = {};
            Object.keys(params).forEach((key) => {
                attr[key] = this.$_.get(this, params[key]);
            });
            return attr;
        },
        buildLayout() {
            // We'll just use default for now
            let layout = this.$config("screen.printLayouts.testing");

            const sections = this.$config("screen.printSections");
            layout.pages = layout.pages.map((sectionNames) => {
                return sectionNames.map((sectionName) => sections[sectionName]);
            });
            this.layout = layout;
        },
    },
};
</script>

<style scoped>
</style>